import { Project, PageModel, GetProjectsByFilterProps } from '@brg/api';
import { createSlice } from '@reduxjs/toolkit';
import { 
    fetchInfiniteProjects, 
    fetchInfiniteProjectsMore, 
    fetchInfiniteProjectsWithUpdate 
} from '../actions/infinityProjectsActions';
const PROJECTS_COUNT_START_OFFSET = 0;
const PROJECTS_COUNT_OFFSET = 20;

interface ITabs {
    [key: string]: Project<'Local' | 'Global'>[]
    // entity: string[] | unknown;
    // name: string | unknown;
    // data?: Project<'Local' | 'Global'>[];
}

interface IPagingList {
    [key: string]: {
        offset: number;
        limit: number;
        count: number;
        pages: number;
        page: number;
    }[]
}

interface InfinityProjectsState extends GetProjectsByFilterProps {
    data: Project<'Local' | 'Global'>[];
    preloadData: ITabs;
    isTabsLoading: boolean;
    paging: {
        offset: number;
        limit: number;
        count: number;
        pages: number;
        page: number;
    };
    pagingList: IPagingList;
    filter: GetProjectsByFilterProps;
    prevFilter: GetProjectsByFilterProps;
    isLoading: boolean;
    isProjectPage:boolean;
    isNeedShowPreload: boolean;
    isFinalPage: boolean;
}

export const InfinityProjectsSlice = createSlice({
    name: 'projects',
    initialState: {
        data: [],
        preloadData: {},
        pagingList: {},
        isTabsLoading: false,
        paging: {
            offset: PROJECTS_COUNT_START_OFFSET
        },
        filter: {},
        prevFilter: {},
        isLoading: false,
        isProjectPage: false,
        isFinalPage: false,
        isNeedShowPreload: true
    },
    reducers: {
        clear: (state) => {
            state = {
                data: [],
                preloadData: {},
                pagingList: {},
                isTabsLoading: false,
                paging: {
                    offset: PROJECTS_COUNT_START_OFFSET
                },
                filter: {},
                prevFilter: state.filter,
                isLoading: false,
                isFinalPage: false,
                isProjectPage: state.isProjectPage,
                isNeedShowPreload: true
            }
        },
        clearOffset: (state) => {
            state.paging = {
                offset: PROJECTS_COUNT_START_OFFSET,
            };
        },
        clearProjects: (state) => {
            state.data = []
        },
        clearPreloadProjects: (state) => {
            state.preloadData = {}
        },
        setFilter: (state, action) => {
            state.filter = {...action.payload};
        },
        setPaging: (state, action) => {
            state.paging = {...action.payload};
            state.isFinalPage = action.payload.page >= action.payload.pages
        },
        setIsProjectPage: (state, action) => {
            state.isProjectPage = action.payload;
        },
        setIsNeedShowPreload: (state, action) => {
            state.isNeedShowPreload = action.payload;
        },
        clearFinalPage: (state, action) => {
            state.isFinalPage = false
        }
    },
    extraReducers: {
        //Начальная с обновлением стейта
        [fetchInfiniteProjects.fulfilled.toString()]: (state, action) => {
            //@ts-ignore
            if (state?.filter?.requestContext === action.payload.context) {
                state.preloadData = action.payload?.all;
                state.paging = action.payload?.paging;
                state.isFinalPage = action.payload?.isFinalPage;
                state.pagingList = action.payload?.pagingAll;
                state.isTabsLoading = false;
            }
        },
        [fetchInfiniteProjects.rejected.toString()]: (state, action) => {
            state.data = [];
            state.isTabsLoading = false;
        },
        [fetchInfiniteProjects.pending.toString()]: (state, action) => {
            if (Object.keys(state.preloadData)?.length === 0) {
                state.isTabsLoading = true;
            }
        },

        //Подгрузка по клику или авто
        [fetchInfiniteProjectsMore.fulfilled.toString()]: (state, action) => {
            //@ts-ignore
            state.data = action.payload.data;
            state.paging = {...action.payload.paging};
            state.isLoading = false;
            // state.isFinalPage = action.payload?.paging?.pages === action.payload?.paging?.page;
            state.isFinalPage = action.payload?.isFinalPage;
        },
        [fetchInfiniteProjectsMore.rejected.toString()]: (state, action) => {
            state.isLoading = false;
        },
        [fetchInfiniteProjectsMore.pending.toString()]: (state, action) => {
            state.isLoading = true;
        },

        //После смены страницы в пагинации
        [fetchInfiniteProjectsWithUpdate.fulfilled.toString()]: (state, action) => {
            state.data = action.payload.data;
            state.paging = {...action.payload.paging};
            state.isLoading = false;
            state.isFinalPage = action.payload?.isFinalPage;
        },
        [fetchInfiniteProjectsWithUpdate.rejected.toString()]: (state, action) => {
            state.isLoading = false
        },
        [fetchInfiniteProjectsWithUpdate.pending.toString()]: (state, action) => {
            state.isLoading = true
        },
    }
});

export default InfinityProjectsSlice
export const InfinityProjectsActions = InfinityProjectsSlice.actions
export const InfinityProjectsSelector = (store: { projects: InfinityProjectsState }): InfinityProjectsState => store.projects;
import { Project, PageModel, GetProjectsByFilterProps } from '@brg/api';
import { createSlice } from '@reduxjs/toolkit';
import { 
    fetchInfiniteProjects, 
    fetchInfiniteProjectsMore, 
    fetchInfiniteProjectsWithUpdate 
} from '../actions/infinityProjectsActions';
const PROJECTS_COUNT_START_OFFSET = 0;
const PROJECTS_COUNT_OFFSET = 20;

interface ITabs {
    [key: string]: Project<'Local' | 'Global'>[]
    // entity: string[] | unknown;
    // name: string | unknown;
    // data?: Project<'Local' | 'Global'>[];
}

interface IPagingList {
    [key: string]: {
        offset: number;
        limit: number;
        count: number;
        pages: number;
        page: number;
    }[]
}

interface InfinityProjectsState extends GetProjectsByFilterProps {
    data: Project<'Local' | 'Global'>[];
    preloadData: ITabs;
    isTabsLoading: boolean;
    paging: {
        offset: number;
        limit: number;
        count: number;
        pages: number;
        page: number;
    };
    pagingList: IPagingList;
    filter: GetProjectsByFilterProps;
    prevFilter: GetProjectsByFilterProps;
    isLoading: boolean;
    isProjectPage:boolean;
    isNeedShowPreload: boolean;
    isFinalPage: boolean;
}

export const InfinityProjectsSlice = createSlice({
    name: 'projects',
    initialState: {
        data: [],
        preloadData: {},
        pagingList: {},
        isTabsLoading: false,
        paging: {
            offset: PROJECTS_COUNT_START_OFFSET
        },
        filter: {},
        prevFilter: {},
        isLoading: false,
        isProjectPage: false,
        isFinalPage: false,
        isNeedShowPreload: true
    },
    reducers: {
        clear: (state) => {
            state = {
                data: [],
                preloadData: {},
                pagingList: {},
                isTabsLoading: false,
                paging: {
                    offset: PROJECTS_COUNT_START_OFFSET
                },
                filter: {},
                prevFilter: state.filter,
                isLoading: false,
                isFinalPage: false,
                isProjectPage: state.isProjectPage,
                isNeedShowPreload: true
            }
        },
        clearOffset: (state) => {
            state.paging = {
                offset: PROJECTS_COUNT_START_OFFSET,
            };
        },
        clearProjects: (state) => {
            state.data = []
        },
        clearPreloadProjects: (state) => {
            state.preloadData = {}
        },
        setFilter: (state, action) => {
            state.filter = {...action.payload};
        },
        setPaging: (state, action) => {
            state.paging = {...action.payload};
            state.isFinalPage = action.payload.page >= action.payload.pages
        },
        setIsProjectPage: (state, action) => {
            state.isProjectPage = action.payload;
        },
        setIsNeedShowPreload: (state, action) => {
            state.isNeedShowPreload = action.payload;
        },
        clearFinalPage: (state, action) => {
            state.isFinalPage = false
        }
    },
    extraReducers: {
        //Начальная с обновлением стейта
        [fetchInfiniteProjects.fulfilled.toString()]: (state, action) => {
            //@ts-ignore
            if (state?.filter?.requestContext === action.payload.context) {
                state.preloadData = action.payload?.all;
                state.paging = action.payload?.paging;
                state.isFinalPage = action.payload?.isFinalPage;
                state.pagingList = action.payload?.pagingAll;
                state.isTabsLoading = false;
            }
        },
        [fetchInfiniteProjects.rejected.toString()]: (state, action) => {
            state.data = [];
            state.isTabsLoading = false;
        },
        [fetchInfiniteProjects.pending.toString()]: (state, action) => {
            if (Object.keys(state.preloadData)?.length === 0) {
                state.isTabsLoading = true;
            }
        },

        //Подгрузка по клику или авто
        [fetchInfiniteProjectsMore.fulfilled.toString()]: (state, action) => {
            //@ts-ignore
            state.data = action.payload.data;
            state.paging = {...action.payload.paging};
            state.isLoading = false;
            // state.isFinalPage = action.payload?.paging?.pages === action.payload?.paging?.page;
            state.isFinalPage = action.payload?.isFinalPage;
        },
        [fetchInfiniteProjectsMore.rejected.toString()]: (state, action) => {
            state.isLoading = false;
        },
        [fetchInfiniteProjectsMore.pending.toString()]: (state, action) => {
            state.isLoading = true;
        },

        //После смены страницы в пагинации
        [fetchInfiniteProjectsWithUpdate.fulfilled.toString()]: (state, action) => {
            state.data = action.payload.data;
            state.paging = {...action.payload.paging};
            state.isLoading = false;
            state.isFinalPage = action.payload?.isFinalPage;
        },
        [fetchInfiniteProjectsWithUpdate.rejected.toString()]: (state, action) => {
            state.isLoading = false
        },
        [fetchInfiniteProjectsWithUpdate.pending.toString()]: (state, action) => {
            state.isLoading = true
        },
    }
});

export default InfinityProjectsSlice
export const InfinityProjectsActions = InfinityProjectsSlice.actions
export const InfinityProjectsSelector = (store: { projects: InfinityProjectsState }): InfinityProjectsState => store.projects;
